import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

function progressBarClass(pct) {
  if (pct >= 80) return '[&>div]:bg-emerald-500 bg-emerald-100 dark:bg-emerald-950/40';
  if (pct >= 50) return '[&>div]:bg-amber-500 bg-amber-100 dark:bg-amber-950/40';
  return '[&>div]:bg-rose-500 bg-rose-100 dark:bg-rose-950/40';
}

/**
 * Hero compliance-only card (no action chips).
 */
export const HeroComplianceProgressCard = ({ compliancePct = 0, onClick }) => {
  const roundedPct = Math.round(Math.min(100, Math.max(0, compliancePct)));

  const content = (
    <CardContent className="p-5 space-y-3">
      <h3 className="text-base font-semibold text-foreground">Compliance</h3>
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground font-medium">Compliance rate</span>
          <span className="font-bold text-foreground tabular-nums" data-testid="hero-compliance-pct">
            {roundedPct}%
          </span>
        </div>
        <Progress
          value={Math.max(roundedPct, roundedPct === 0 ? 0 : 2)}
          className={`h-3 ${progressBarClass(roundedPct)}`}
          data-testid="hero-compliance-progress-bar"
        />
        {roundedPct === 0 && (
          <p className="text-xs text-muted-foreground">Review outstanding requirements to improve compliance.</p>
        )}
      </div>
    </CardContent>
  );

  if (onClick) {
    return (
      <Card
        onClick={onClick}
        className="w-full max-w-[320px] flex-shrink-0 border-none shadow-md bg-white dark:bg-gray-900 cursor-pointer hover:shadow-lg transition-shadow"
        data-testid="hero-compliance-progress-card"
      >
        {content}
      </Card>
    );
  }

  return (
    <Card
      className="w-full max-w-[320px] flex-shrink-0 border-none shadow-md bg-white dark:bg-gray-900"
      data-testid="hero-compliance-progress-card"
    >
      {content}
    </Card>
  );
};

export default HeroComplianceProgressCard;
